<script>
import ModalExport from './ModalExport.vue';
export default {
    name:"AdminFilter",
    props:[],
    data: ()=>({
        rows: [],
        filterStatus: false,
        showModalExport: false,
    }),
    components: {ModalExport},
    methods:{
        filter: function(){
            this.$store.dispatch("getDataReport").then((res)=>{
                if(res.status){
                    this.filterStatus = true;

                    this.rows = res.data;
                }else{
                    if(!res.auth){
                        alert("Sessão encerrado ou usuário não autorizado. Favor realizar o login novamente.");
                        this.$store.dispatch("logout").then(()=>{
                            this.$router.push("/admin/login");
                        });
                    }
                }
            })
        },
        actualDate: function(){
            let n =  new Date();
            let y = n.getFullYear();
            let m = n.getMonth() + 1;
            let d = n.getDate();
            if(m < 10)
                m = '0' + m.toString();
            else if(d < 10)
                d = '0' + d.toString();

            if(d < 10)
                d = '0' + d.toString();

            let maxDate = y + '-' +(parseFloat(0+m)) + '-' + d
            return maxDate;
        },
    },
    computed:{
        formReport:{
            get(){
                return this.$store.getters.formReport;
            },
            set(value){
                this.$store.commit("SET_FORM_REPORT",value);
            }
        }
    },
    created(){
        this.formReport.DateIn = this.actualDate();
        this.formReport.DateOut = this.actualDate();

    }
}
</script>
<template>
    <div id="AdminFilter">
        <div class="panel">
            <div class="container">
                <div class="report-field">
                    <label for="Nome">Nome</label>
                    <input type="text" name="Nome" id="Nome" v-model="formReport.Nome" v-on:keyup.enter="filter()">
                </div>
                <div class="report-field">
                    <label for="DateIn">Data Inicial</label>
                    <input type="date" name="DateIn" id="DateIn" v-model="formReport.DateIn" v-on:keyup.enter="filter()" min="2021-08-09" :max="actualDate()">
                </div>
                <div class="report-field">
                    <label for="DateOut">Data Fim</label>
                    <input type="date" name="DateOut" id="DateOut" v-model="formReport.DateOut" v-on:keyup.enter="filter()" min="2021-08-09" :max="actualDate()" >
                </div>
                <!-- <div class="report-field">
                    <label for="DateAdd">DateAdd</label>
                    <input type="date" name="DateAdd" id="DateAdd" v-model="formReport.DateAdd" v-on:keyup.enter="filter()" min="2021-08-09" max="2021-09-21" >
                </div> -->
            </div>
            <div class="controls">
                <button @click="filter()">Filtrar</button>
                <button @click="showModalExport = true" :disabled="!filterStatus" class="csv">CSV</button>
            </div>
        </div>

        <modal-export v-if="showModalExport" @close="showModalExport = false" :data="rows" />
    </div>
</template>
<style lang="scss">
.panel{
    width: 100%;
    background: #f3f4f6;
    padding: 0;

    display: flex;

    .container{
        display: flex;
        height: 90px;
        align-items: center;
        justify-content: flex-start;
        padding: 40px;
    }

    .report-field{
        display: flex;
        flex-direction: column;
        align-items: center;

        input[type="date"]{
            min-width: 160px;
            margin-left: 20px;
        }
    }

    .controls{
        display: flex;

        button{
            background: #3b82f6;
            color: white;
            font-size: 1.2em;            
            padding: 0 20px;

            &:disabled{
                cursor: not-allowed;
            }

            &.csv{
               background: #085adf;
               padding: 8px 21px;
            }
        }
    }
}
</style>